import { com } from '@eidu/web'
import { useMemo } from 'react'
import DraftFieldValue from './DraftFieldValue'
import EntityWithLabelAndRelated from './EntityWithLabelAndRelated'
import hasFieldError from './hasFieldError'
import useEntityById from '../../io/useEntityById'
import EqualityHashMap from '../../util/EqualityHashMap'
import Field = com.eidu.entity.field.Field
import EntityId = com.eidu.entity.EntityId
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import FieldType = com.eidu.entity.field.FieldType
import entityIdFromStringOrNull = com.eidu.entity.entityIdFromStringOrNull

export type UseReferenceFieldErrorResult = {
  hasError: boolean
  selectedEntity: EntityWithLabelAndRelated | null | undefined
  loading: boolean
}

const useReferenceFieldError = (
  field: Field,
  fieldValue: DraftFieldValue | undefined,
  disabled: boolean = false
): UseReferenceFieldErrorResult => {
  const selectedId =
    field.type === FieldType.Reference && fieldValue?.value
      ? entityIdFromStringOrNull(fieldValue.value) ?? undefined
      : undefined
  const { entity: selectedEntity, loading } = useEntityById(selectedId)

  const selectedEntityByTypeId: ReadonlyMap<EntityTypeId, ReadonlyMap<EntityId, EntityWithLabelAndRelated>> = useMemo(
    () =>
      selectedEntity
        ? new EqualityHashMap([
            [selectedEntity.entity.typeId, new EqualityHashMap([[selectedEntity.entity.id, selectedEntity]])],
          ])
        : new Map(),
    [selectedEntity]
  )

  const hasError =
    disabled || loading
      ? false
      : selectedId !== undefined && selectedEntity === null
        ? true
        : hasFieldError(field, fieldValue, selectedEntityByTypeId)

  return { hasError, selectedEntity, loading }
}

export default useReferenceFieldError
